<template>
  <div
    style="
      height: 970px;
      background-repeat: no-repeat;
      background-size: 1178px 634px;
      background-image: url(https://img.uelink.com.cn/upload/xin_li_monitor/bg_img.png);
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -336px;
        margin-left: -288px;
      "
    >
      <img
        src="https://img.uelink.com.cn/upload/xin_li_monitor/report_tem.png"
        style="width: 553px; height: 647px"
      />
      <div
        style="
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 21px;
          color: #ffffff;
          text-align: center;
          width: 330px;
          margin: -330px auto 0;
        "
      >
        <div>温馨提示：</div>
        <div>
          关注微信公众号“{{xyOriginBool?'粤心研青少年心理':xyOriginBool?'心悦心理':'青少年心理'}}成长监测中心” 回复“<span
            style="color: #ffd034; font-weight: bold"
            >{{ testingId || '' }}</span
          >”获取本次详细完整的测评报告。
        </div>
        <img
          style="display: block; margin: 20px auto; width: 157px; height: 157px"
          :src="yxyOriginBool?yxyGzhImgUrl:xyOriginBool?xyGzhImgUrl:gzhImgUrl"
        />
        <button
          style="
            border-radius: 25px;
            box-sizing: border-box;
            width: 200px;
            margin: 0 auto;
            height: 50px;
            line-height: 50px;
            background: #ffd034;
            text-align: center;
            font-size: 18px;
            color: #596df8;
            border: none;
            outline: none;
          "
          @click="goBackHome"
        >
          返回首页
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="panel" style="width: 850px;margin: 10px auto;">
     <div class="tit">您的测评结果报告</div>
      <div class="report">您本次心理测评已完成，专属的个人测评报告已生成。</div>
     <div class="tips">
     <div>关注微信公众号“青少年心理成长监测中心”</div>
     <div>回复“<span style="color:#5a6ef9;font-weight: bold;">{{testingId}}</span>”获取本次详细完整的测评报告。</div>
     </div>
       <img style="display: block;margin-left: auto;margin-right: auto;width:400px;height: 400px;" src="../../static/qingshaonian_gzh.jpg" />

         <button class="btn" @click="goBackHome">返回首页</button>
 </div> -->
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "component_name",
  data() {
    return {
      xyOriginBool: false,
      yxyOriginBool: false,
      gzhImgUrl:require('@/static/qingshaonian_gzh.jpg'),
      xyGzhImgUrl:require('@/static/xinyue_gzh.jpg'),
      yxyGzhImgUrl:require('@/static/yuexinyan_gzh.jpg')
    };
  },
  computed: {
    ...mapGetters(['orgId', 'examId'])
  },
  created () {
    console.log(this.orgId,this.examId);
    
    console.log(this.$route, "this.$router");
    console.log(this.$route.query.testingId, "this.$router.query.testingId");
    this.testingId = this.$route.query.testingId;
    const xyOriginBool = this.$store.state.user.xyOriginBool
    const yxyOriginBool = this.$store.state.user.yxyOriginBool
    if (xyOriginBool) {
        this.xyOriginBool = xyOriginBool
    }
    if (yxyOriginBool) {
        this.yxyOriginBool = yxyOriginBool
    }
  },
  methods: {
    goBackHome: function () {
      this.$router.push(`home?orgId=${this.orgId}&examId=${this.examId}`)
    },
  },
};
</script>
<style lang="less" scoped>
.btn {
  border-radius: 8px;
  box-sizing: border-box;
  width: 85%;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
  background: #5a6ef9;
  text-align: center;
  font-size: 8px;
  color: #fff;
  border: none;
  outline: none;
}
.tit {
  font-size: 8px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
}
.report {
  font-size: 6px;
}
.tips {
  margin-top: 5px;
  font-size: 6px;
  line-height: 15px;
}
.panel {
  display: flex;
  flex-flow: column;
  background-color: #ffffff;
  text-align: center;
  border-radius: 10rpx;
  box-shadow: 0px 10px 20px 0px rgba(90, 110, 249, 0.2);
}
</style>